module.exports = __webpack_public_path__ + "images/sam/bg-v.gif";